import { render, staticRenderFns } from "./UserDisableModal.vue?vue&type=template&id=b675147e&"
import script from "./UserDisableModal.vue?vue&type=script&lang=js&"
export * from "./UserDisableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports